module.exports = "<br><br><br>\n<app-loading [hidden]=\"!loading\"></app-loading>"